module.exports = __webpack_public_path__ + "img/bildhauer1.ced4ddaf.jpg";